import { Injectable } from '@angular/core';
import { AppService } from '../App/app.service';
import { GLanguageProvider } from './g-language.provider';
import { GeneralExerciseComponent } from './g-exercise.component';
import { GeneralTeacherComponent } from './gt.component';
import { TopicService } from '../compression/topic.service';

@Injectable()
export class GTopicService {

  protected configuration: any = null;
  protected state: any = null;
  protected language: any = null;
  protected languageAbbrev: string = null;
  public type;


  constructor(protected languageProvider: GLanguageProvider, protected appService: AppService) {
    this.appService.registerLanguageChangeCallback(this.changeLanguage.bind(this));
    this.changeLanguage(this.appService.languageAbbreviation);
  }

  /** get text in right language 
* @param {string} tag - text to load
*/
  get(tag: string): string {
    let result: string = this.language[tag];
    if (result == undefined || result == "" || result == null) {
      result = this.appService.get(tag);
    }
    return result;
  }

  /** returns title of topic */
  getTitle(): string {
    return this.configuration["title"];
  }

  /** returns id of topic */
  getId(): number {
    return this.configuration["id"];
  }

  /** returns type of topic */
  getType(): string {
    return this.configuration["type"];
  }

  /** returns title of topic */
  getImage(): string {
    return this.configuration["image"];
  }

  /** returns all exercises  */
  getAllExercises(): any[] {
    this.configuration = this.appService.getTopicConfiguration(this.type);
    return this.configuration["exercises"];
  }

  /** returns all exams  */
  getAllExams(): any[] {
    this.configuration = this.appService.getTopicConfiguration(this.type);
    return this.configuration["exams"];
  }

  /** returns for all exercises the id, the title, the type and the image and the state(solved)*/
  getAllExercisesInfo(): any[] {
    this.configuration = this.appService.getTopicConfiguration(this.type);
    var allExercises: any[] = this.configuration["exercises"];
    var result: any[] = [];
    var temp: any = {};
    for (let exercise of allExercises) {
      temp.id = exercise["id"];
      temp.image = exercise["image"];
      temp.title = exercise["title"];
      temp.type = exercise["type"];
      temp.key = exercise["key"];
      temp.level = exercise["level"];
      let state = this.getStateByKey(temp.key);
      temp.solved = false;
      if (state != undefined) {
        if (state.solved != undefined) {
          temp.solved = state.solved;
        }
      }
      result.push(temp);
      temp = {};
    }
    return result;
  }

  /** returns the titles of all exercises for this topic */
  getAllExerciseTitles(): string[] {
    var allExercises: any[] = this.configuration["exercises"];
    var result: string[] = [];
    for (let exercise of allExercises) {
      result.push(exercise["title"]);
    }
    return result;
  }

  /** returns the Configuration for a specific exercise
   * @param {number} id - the id of the requested exercise
   */
  getExerciseById(examid: number, id: number): any {
    var allExercises: any[] = this.configuration["exercises"];
    if (examid > -1) {
      var exam: any = this.getExamById(examid);
      allExercises = exam["questions"];
    }
    for (let exercise of allExercises) {
      if (exercise["id"] == id) {
        return exercise;
      }
    }
    return {};
  }

  /** returns the Configuration for a specific exercise
   * @param {number} id - the id of the requested exercise
   */
  getExamById(id: number): any {
    var allExams: any[] = this.configuration["exams"];
    for (let exam of allExams) {
      if (exam["id"] == id) {
        return exam;
      }
    }
    return {};
  }

  /** returns for all exams the id, the title, the type, the image and the state(solved)*/
  getAllExamsInfo(): any[] {
    this.configuration = this.appService.getTopicConfiguration(this.type);
    var allExams: any[] = this.configuration["exams"];
    var result: any[] = [];
    var temp: any = {};
    for (let exam of allExams) {
      temp.id = exam["id"];
      temp.image = exam["image"];
      temp.title = exam["title"];
      temp.type = exam["type"]
      temp.key = exam["key"];
      temp.level = exam["level"];
      let state = this.getStateByKey(temp.key);
      temp.solved = false;
      if (state != undefined) {
        if (state.solved != undefined) {
          temp.solved = state.solved;
        }
      }
      result.push(temp);
      temp = {};
    }
    return result;
  }

  /** returns whether a exam is marked as exam or not */
  isExam(id: number): boolean {
    if (id < 0) {
      return false;
    }
    let exam = this.getExamById(id);
    return exam.isExam;
  }


  /** returns all Question Information for the given exam id */
  getAllQuestionInfosById(id: number) {
    let exam = this.getExamById(id);
    let allQuestions = exam["questions"];
    var result: any[] = [];
    var temp: any = {};
    for (let question of allQuestions) {
      temp.id = question["id"];
      temp.image = question["image"];
      temp.title = question["title"];
      temp.type = question["type"];
      temp.key = question["key"];
      temp.level = question["level"];
      let state = this.getStateByKey(temp.key);
      temp.solved = false;
      temp.evaluate = 0;
      temp.maxPoints = 0;
      temp.correct = false;
      if (state != undefined) {
        if (state.solved != undefined) {
          temp.solved = state.solved;
        }
        if (state.evaluate != undefined) {
          temp.evaluate = state.evaluate;
        }
        if (state.maxPoints != undefined) {
          temp.maxPoints = state.maxPoints;
        }

        if (state.evaluate != undefined && state.maxPoints != undefined) {
          if (state.evaluate == state.maxPoints && state.maxPoints != 0) {
            temp.correct = true;
          }
        }
      }


      result.push(temp);
      temp = {};
    }
    return result;
  }

  /** returns all Questions of the given examId 
   * @param id: examId
  */
  getAllQuestionsById(id: number) {
    let exam = this.getExamById(id);
    let allQuestions = exam["questions"];
    return allQuestions;
  }

  /** returns the state of the exercise with the given key 
   * @param key: exerciseKey
  */
  getStateByKey(key: string): any {
    var allExercises: any[] = this.state["exercises"];
    for (let exercise of allExercises) {
      if (exercise["key"] == key) {
        return exercise;
      }
    }
    let state = { typespecific: {} };
    return state;
  }

  /** returns the maximal id found in the all exercise for this topic */
  getMaxId(examId: number = -1): number {
    let allExercises = this.getAllExercises();
    if (examId > -1) {
      allExercises = this.getAllQuestionsById(examId);
    }
    let maxId = 0;

    for (let exercise of allExercises) {
      if (exercise.id > maxId) {
        maxId = exercise.id;
      }
    }
    return maxId;
  }

  /** returns the maximal id found in the exams for this topic */
  getMaxExamId(): number {
    let allExams = this.getAllExamsInfo();
    let maxId = 0;
    for (let exam of allExams) {
      if (exam.id > maxId) {
        maxId = exam.id;
      }
    }
    return maxId;
  }

  /** returns position in array of exercise with id withing the configuration
   * @param {number} id - id of requested exercise
  */
  getPositionByIdConfiguration(id: number, allItems: any): number {
    let index = 0;
    for (let item of allItems) {
      if (item.id == id) {
        return index;
      }
      index++;
    }
    return -1;
  }

  /** returns position in array of exercise with id withing the configuration
   * @param {number} key - id of requested exercise
  */
  getPositionByKeyState(key: string): number {
    let allExercises = this.state["exercises"];
    let index = 0;
    for (let exercise of allExercises) {
      if (exercise["key"] == key) {
        return index;
      }
      index++;
    }
    return -1;
  }

  /** requests the appService to add this to the configuration 
   * @param {any} definition - holds the specification of the exercise
  */
  addExercise(definition: any) {
    this.configuration.exercises.push(definition);
    this.appService.updateConfiguration(this.type, this.configuration);
  }

  /** adds the given definition as exam */
  addExam(definition: any) {
    this.configuration.exams.push(definition);
    this.appService.updateConfiguration(this.type, this.configuration);
  }

  /** adds the given definition as question to the given exam */
  addQuestion(examId: number, definition: any) {
    let exam = this.getExamById(examId);
    exam.questions.push(definition);
    this.updateExam(exam);

  }
  /** requests the appService to update this exercise
     * @param {any} definition - holds the specification of the exercise
    */
  updateExercise(definition: any) {
    this.configuration.exercises[this.getPositionByIdConfiguration(definition.id, this.getAllExercisesInfo())] = definition;
    this.appService.updateConfiguration(this.type, this.configuration);
  }

  /** requests the appService to update this exam question
    * @param {any} definition - holds the specification of the exercise
   */
  updateQuestion(examId: number, definition: any) {
    let exam = this.getExamById(examId);
    exam.questions[this.getPositionByIdConfiguration(definition.id, this.getAllQuestionInfosById(examId))] = definition;
    this.appService.updateConfiguration(this.type, this.configuration);
  }

  /** requests the appService to update this exercise
     * @param {any} definition - holds the specification of the exercise
    */
  updateExam(definition: any) {
    this.configuration.exams[this.getPositionByIdConfiguration(definition.id, this.getAllExamsInfo())] = definition;
    this.appService.updateConfiguration(this.type, this.configuration);
  }

  /** requests the appService to update all the exercises 
   * @param {any} definition - new exercises
  */
  updateAllExercises(definition: any) {
    this.configuration.exercises = definition;
    this.appService.updateConfiguration(this.type, this.configuration);
  }

  /** requests the appService to update all the exercises 
   * @param {any} definition - new exercises
  */
  updateAllExams(definition: any) {
    this.configuration.exams = definition;
    this.appService.updateConfiguration(this.type, this.configuration);
  }

  /** requests the appService to update all the exercises 
  * @param {any} definition - new exercises
 */
  updateAllQuestions(definition: any, examId: number) {
    let exam = this.getExamById(examId);
    exam.questions = definition;
    this.appService.updateConfiguration(this.type, this.configuration);
  }

  /** sets the state 
   * @param {string} key - key of exercise to set
   * @param {any} state - state to set
  */
  setStateByKey(key: string, state: any) {
    state.key = key;
    let position = this.getPositionByKeyState(key);
    if (position < 0) {
      this.state.exercises.push(state);
    } else {
      this.state.exercises[position] = state;
    }
    this.appService.setState(this.type, this.state);
  }

  /** resets the satet of the given key
   * @param {string} key: key of state to reset
   */
  resetStateByKey(key: string) {
    let position = this.getPositionByKeyState(key);
    if (position < 0) {
      return;
    } else {
      this.state.exercises.splice(position, 1);
    }
    this.appService.setState(this.type, this.state);
  }

  /** registers the current exercise */
  registerExerise(exercise: GeneralExerciseComponent) {
    this.appService.currentExercise = exercise;
  }

  /** registers the current exercise */
  registerTeacherExerise(exercise: GeneralTeacherComponent) {
    this.appService.currentTeacherExercise = exercise;
  }

  /** redirects to next exercise */
  nextClicked(): any {
    let id = this.appService.currentExercise.getID();
    let allExercises = this.getAllExercisesInfo();
    let index = 0;
    let found = false;
    for (let exercise of allExercises) {
      if (found) {
        return { path: exercise.type, id: exercise.id };
      }
      if (exercise.id == id) {
        found = true;
      }
      index++;
    }
    return { path: "", id: undefined };
  }

  /** sets all exercises the exam to solved */
  setQuestionsSolved(examId: number) {
    let allQuestions = this.getAllQuestionsById(examId);
    for (let q of allQuestions) {
      let state = this.getStateByKey(q.key);
      state.solved = true;
      this.setStateByKey(q.key, state);
    }
    let exam = this.getExamById(examId);
    let state = this.getStateByKey(exam.key);
    state.solved = true;
    this.setStateByKey(exam.key, state);
  }

  /** challback function on language change, registered at the appService*/
  changeLanguage(language: string) {
    this.languageProvider.loadLanguage(language).then(language => this.language = this.languageProvider.getLanguage());
  }

  /** return the language defined in applicationService */
  getLanguage(): string {
    return this.appService.languageAbbreviation;
  }


  /** Determines the visibility of a given tip */
  showTip(name: string): boolean {
    return this.appService.showTip(name);
  }

  /** closes the given tip permanently */
  closeTip(name: string) {
    this.appService.closeTip(name);
  }

  /** tell whether or not the teachers place is visible */
  isTeachersPlaceVisible():boolean{
    return this.appService.isTeachersPlaceVisible();
  }

}
